import { render, staticRenderFns } from "./projectsDetailsComponent.vue?vue&type=template&id=55df0ce4&"
import script from "./projectsDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./projectsDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./projectsDetailsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports